/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { FILEURL, PUBLISH_REPORT, ENTITYNAME, OPERATORS, LOCALSTORAGE_KEY, MODULETYPES, SCHEDULETYPE, REPORT_TYPE, MEDIACATEGORIES, FILTER_CRITERIA_MEDIA_CONTENT_REPORT, TOAST_TYPES } from "../../framework/constant/constant";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useNavigate } from "react-router-dom";
import { utility } from "../../framework/utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import { RadioButton } from "@progress/kendo-react-inputs";
import MyMultiSelect from "../../components/MyMultiSelect";
import ToastNotification from "../../components/ToastNotification";


export const MediaContentReport = (props) => {

    const blankDataItem = {
        MediaCategory: { SID: 0, Description: "All" },
        MediaCategoryType: { SID: 0, Description: "All" },
        FilterCriteria: { _id: 0, Description: "ALL" },
        FromDate: "",
        ToDate: "",
        Keyword: "",
        Channel: []
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const lang = useTranslation();
    const [isLongContent, setIsLongContent] = useState(true);
    const [mediaCategories, setMediaCategories] = useState([]);
    const [mediaCategoryTypes, setMediaCategoryTypes] = useState([]);
    const [filterMediaCategory, setFilterMediaCategory] = useState([]);
    const [filterMediaCategoryType, setFilterMediaCategoryType] = useState([]);
    const [footerMessage, setFooterMessage] = useState('');
    const [filterCriterias, setFilterCriterias] = useState([]);
    const [selectAllChannels, setSelectAllChannels] = useState(false);
    const [channel, setChannel] = useState([]);
    const [isExporting, setIsExporting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        let mediaCategoryRes = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { SID: 1 } });
        setMediaCategories([
            ...mediaCategoryRes.data.filter((x) =>
                x.SID != MEDIACATEGORIES.Series && x.SID != MEDIACATEGORIES.Season
            )
        ]);

        setFilterMediaCategory([{ SID: 0, Description: "All" }, ...mediaCategoryRes.data.filter((x) => x.isLong && x.SID != MEDIACATEGORIES.Series && x.SID != MEDIACATEGORIES.Season)]);
        let mediaCategoryTypeRes = await API.getDataLookup(ENTITYNAME.MediaCategoryType, { sort: { SID: 1 } });
        setMediaCategoryTypes([{ SID: 0, Description: "All" }, ...mediaCategoryTypeRes.data]);

        const filterCriteriaRes = Object.keys(FILTER_CRITERIA_MEDIA_CONTENT_REPORT).map(key => ({
            _id: FILTER_CRITERIA_MEDIA_CONTENT_REPORT[key],
            Description: key
        }));
        setFilterCriterias(filterCriteriaRes);
        let channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        channelRes.data.unshift({ _id: null, FullChannelName: "All" })
        setChannel(channelRes.data);
    }

    const loadAndExportData = async () => {

        setIsExporting(true);
        setFooterMessage(lang.please_wait_export_report_message);

        const payload = {
            mediaCategory: dataItem.MediaCategory?.SID ?? 0,
            mediaCategoryType: dataItem.MediaCategoryType?.SID ?? 0,
            isLong: isLongContent,
            FilterCriteria: dataItem?.FilterCriteria?._id,
            FromDate: dataItem?.FromDate ? utility.convertStringDatetoMilliseconds(dataItem?.FromDate) : null,
            ToDate: dataItem?.ToDate ? utility.convertStringDatetoMilliseconds(dataItem?.ToDate) : null,
            Keyword: dataItem?.Keyword ?? "",
            Channel: dataItem?.Channel?.length > 0 ? dataItem?.Channel?.map(x => x._id) : []
        };

        console.log(payload)

        let res = await API.exportMediaContent(payload);

        console.log(res);

        if (res.success) {
            setTimeout(() => {
                window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: ang.content_report_is_exported_successfully_message });
                setFooterMessage(lang.content_report_is_exported_successfully_message);
            }, 5000);
            setIsExporting(false);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setFooterMessage('');
        }

    }

    const onChange = async (e) => {
        if (e.target.name == "IsAllChannel") {
            setSelectAllChannels(!selectAllChannels);
            setDataItem({ ...dataItem, Channel: selectAllChannels ? [] : channel });
        } else if (e.target.name == "MediaCategory") {
            let filterMediaCategoryType = mediaCategoryTypes.filter((x) => x.MediaCategorySID == e.target.value.SID);
            setFilterMediaCategoryType([{ SID: 0, Description: "All" }, ...filterMediaCategoryType]);
            setDataItem({ ...dataItem, MediaCategoryType: { SID: 0, Description: "All" }, MediaCategory: e.target.value });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const onMediaTypeChange = (e) => {

        if (e.value == "LongForm") {
            setIsLongContent(true);
            setFilterMediaCategory(mediaCategories.filter((x) => x.isLong))
        } else {
            setIsLongContent(false);
            setFilterMediaCategory(mediaCategories.filter((x) => !x.isLong))
        }

        setDataItem({ ...blankDataItem });

    }

    return (<>
        {<BossDialog
            title={lang.media_content_report_page_breadcrumb}
            onClose={() => navigate('/home')}
            width={"650px"}
        >
            <div className="col-12" style={{ margin: "02px 0px 0px 0px" }}>
                <div className="row">
                    <div className="col-8">
                        <div className="form-group">
                            <label htmlFor="">
                                <RadioButton
                                    name="LongForm"
                                    value="LongForm"
                                    checked={isLongContent}
                                    label={lang.long_form_label}
                                    onChange={onMediaTypeChange}
                                    disabled={isExporting}
                                />
                                <RadioButton
                                    style={{ marginLeft: "25px" }}
                                    name="ShortForm"
                                    value="ShortForm"
                                    checked={!isLongContent}
                                    label={lang.short_form_label}
                                    onChange={onMediaTypeChange}
                                    disabled={isExporting}
                                />
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="TabView">{lang.media_category_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={filterMediaCategory}
                                name="MediaCategory"
                                textField="Description"
                                dataItemKey="SID"
                                value={dataItem.MediaCategory}
                                onChange={onChange}
                                disabled={isExporting}
                            />
                        </div>
                    </div>
                </div>
                {!isLongContent && <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="TabView">{lang.media_category_type_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={filterMediaCategoryType}
                                name="MediaCategoryType"
                                textField="Description"
                                dataItemKey="SID"
                                value={dataItem.MediaCategoryType}
                                onChange={onChange}
                                disabled={isExporting}
                            />
                        </div>
                    </div>
                </div>}
                <div className="row border mt-2 mb-2">
                    <div className="col-12 mb-2">
                        <div className=" mt-2">
                            <label htmlFor="TabView">{lang.filter_criteria_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={filterCriterias}
                                dataItemKey='_id'
                                name='FilterCriteria'
                                textField='Description'
                                onChange={onChange}
                                value={dataItem.FilterCriteria}
                                disabled={isExporting}
                            />
                        </div>
                        {(dataItem?.FilterCriteria?._id === FILTER_CRITERIA_MEDIA_CONTENT_REPORT.ADDED_BETWEEN ||
                            dataItem?.FilterCriteria?._id === FILTER_CRITERIA_MEDIA_CONTENT_REPORT.EXPIRE_BETWEEN) && (
                                <div className="row mt-2">
                                    <div className="col-6">
                                        <label htmlFor="TabView">{lang.from_date_label}</label>
                                        <input
                                            className="form-control form-control-sm"
                                            name="FromDate"
                                            type="date"
                                            value={dataItem.FromDate}
                                            onChange={onChange}
                                            disabled={isExporting}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label htmlFor="TabView">{lang.to_date_label}</label>
                                        <input
                                            className="form-control form-control-sm"
                                            name="ToDate"
                                            type="date"
                                            value={dataItem.ToDate}
                                            onChange={onChange}
                                            disabled={isExporting}
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row mt-2">
                            <div className="col-12">
                                <label htmlFor="TabView">{lang.channel_label}</label>
                                <span className="float-right">{lang.select_all_label}
                                    <input
                                        type="checkbox"
                                        name="IsAllChannel"
                                        className="ml-1"
                                        value={selectAllChannels}
                                        checked={selectAllChannels}
                                        onChange={onChange}
                                        disabled={isExporting}
                                    />
                                </span>
                                <MyMultiSelect
                                    style={{
                                        backgroundColor: "white",
                                    }}
                                    data={channel}
                                    name="Channel"
                                    textField="FullChannelName"
                                    dataItemKey="_id"
                                    value={dataItem.Channel}
                                    onChange={onChange}
                                    disabled={isExporting}
                                />
                            </div>
                        </div>
                        <div className="row mt-2 mb-2">
                            <div className="col-12">
                                <label htmlFor="TabView">{lang.keyword_label}</label>
                                <input
                                    name="Keyword"
                                    type="text"
                                    value={dataItem.Keyword}
                                    onChange={onChange}
                                    className="form-control form-control-sm"
                                    disabled={isExporting}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginTop: "05px" }}>
                    <div className="col-12">
                        <ActionButton disabled={isExporting} title={lang.export_button_tooltip} name={lang.export_button_text} onClick={loadAndExportData} style={{ margin: '0px', borderRadius: '5px' }} />
                    </div>
                </div>
            </div>
            <div className='text-right mt-3' style={{ position: 'fixed', height: '30px', width: '652px', marginLeft: '-20px', padding: '5px', background: "#3A3633" }}>
                <span style={{ color: 'white' }}>{footerMessage} </span>
            </div>
        </BossDialog>}
    </>)
}
export default MediaContentReport;